import {Input, Output, EventEmitter, OnChanges, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl} from '@angular/forms';

declare const toastr: any;

export abstract class AbstractFieldClass implements OnInit, OnChanges, ControlValueAccessor {
    @Input('value') _value: any = '';
    @Input('type') _type: string;
    @Input('id') _id: number;
    @Input() name: string;
    @Input() editOnly = false;
    @Input() editMode = false;
    @Input() noEdit = false;
    @Input() required = false;
    @Input() openedForEdit = false;
    @Input() longTitle = false;
    @Input() isNumber = false;
    @Output() update: EventEmitter<any> = new EventEmitter<any>();
    @Output() canceled: EventEmitter<any> = new EventEmitter<any>();

    originValue: any;
    isEditMode = false;

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = typeof val === 'string' ? val.trim() : val;
        this.propagateChange(this._value);
    }

    ngOnInit() {
        if (this.openedForEdit)
            this.isEditMode = true;
        if (this.editOnly) this.editModeOn();
        if (this.editMode) this.editModeOn();
        else this.copyValue();
    }

    ngOnChanges(inputs) {
        this.editModeOff();
        this.copyValue();
        this.propagateChange(this.value);
    }

    editModeOn(): void {
        if (this.noEdit) return;
        this.isEditMode = true;
    }

    editModeOff(): void {
        this.isEditMode = false;
    }

    apply(form?): void {
        if (this.required && !this.value) return;
        if (this.isNumber && !this.value.match('^[0-9]*$')) {
            toastr.warning('This value should only contain numbers');
            return;
        }
        if (!this.editOnly) {
            this.editModeOff();
            this.update.emit(this);
            this.copyValue();
        }
    }

    cancel(): void {
        this.editModeOff();
        this.reset();
        this.canceled.emit();
    }

    reset(): void {
        if (this.value && typeof this.value === 'object' && !(this.value instanceof Date && this.originValue === '')) {
            this.value = this.originValue ? JSON.parse(this.originValue) : {};
        } else {
            this.value = this.originValue;
        }
    }

    abstract validator(value: any): boolean;

    copyValue() {
        if (this.value) {
            if (typeof this._value === 'object') {
                this.originValue = JSON.stringify(this.value);
            } else {
                this.originValue = this.value;
            }
        } else {
            this.originValue = '';
        }
    }

    writeValue(value) {
        this.value = value;
        this.copyValue();
    }

    propagateChange: any = () => {
    };

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {
    }

    validate(c: FormControl) {
        return this.validator(c);
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/fields/abstract-field.class.ts